import Textarea from "@mui/joy/Textarea";

function TextArea(props) {
  const { label, register, options, minRows = 4, ...defaultProps } = props;
  const { name } = defaultProps;
  return (
    <div className="text-area">
      <label>{label}</label>
      <Textarea
        color="solid"
        minRows={minRows}
        variant="outlined"
        {...register(name, options)}
        {...defaultProps}
      />
    </div>
  );
}

export default TextArea;
